/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link, Redirect} from 'react-router-dom'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

class EditVersion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      info: {},
      redirect: false
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  componentDidMount() {
    let {id} = this.props.match.params
    http
      .get(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_GET_APPVERSION}?id=${id}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            info: response.data.object
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  EditVersion() {
    let {id} = this.props.match.params
    var code = this.convertDigit(document.getElementById('code').value)
    var stable = document.getElementById('stable').value
    var force = document.getElementById('force').value
    var codeError = false
    var formError = false

    if (code == '') {
      codeError = true
      formError = true
      message.error('شماره کد را مشخص کنید')
    } else if (!code.match(/[1-9\d]/g)) {
      codeError = true
      formError = true
      message.error('شماره کد باید عددی باشد')
    } else if (code < '1') {
      codeError = true
      formError = true
      message.error('شماره کد باید حداقل یک باشد')
    } else {
      if (!codeError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      let data = {
        id: id,
        code: code,
        force: force == 'true' ? force : !force,
        stable: stable == 'true' ? stable : !stable
      }
      // alert(JSON.stringify(data))
      http.post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_EDIT_APPVERSION_INFO}`, data, {}).then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          message.success('ورژن ویرایش شد')
          setInterval(() => {
            window.location.assign('/version')
          }, 2000)
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/version" />
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/version'}>نسخه های اپلیکیشن</Link>
            </li>
            <li>ویرایش نسخه</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ویرایش ورژن</p>
            </div>
            <div className="formComponent">
              <label>
                شماره ورژن <span className="requireFiled">*</span>
              </label>
              <input
                type="number"
                min="1"
                defaultValue={this.state.info.code}
                id="code"
                name="code"
                className="form-control"
              />

              <label>
                وضعیت ثبات <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="stable" name="stable">
                <option value={true} selected={this.state.info.stable ? true : false}>
                  با ثبات
                </option>
                <option value={false} selected={!this.state.info.stable ? true : false}>
                  بی ثبات
                </option>
              </select>

              <label>
                وضعیت دانلود <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="force" name="force">
                <option value={true} selected={this.state.info.force ? true : false}>
                  اجباری
                </option>
                <option value={false} selected={!this.state.info.force ? true : false}>
                  اختیاری
                </option>
              </select>

              <button className="btn btn-primary btn-block" onClick={this.EditVersion.bind(this)}>
                ویرایش
              </button>
              {this.renderRedirect()}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default EditVersion
